import { GenericAnalyticsWidgetDataRequestType, GenericAnalyticsWidgetType } from './analytics'
import { CoverageType, PrerequisiteType, CatalogueConfigType } from './discounts'
import { CatalogueCategoryType, CatalogueDataType } from './common/catalogue'
import { ChannelConfigType } from 'src/lib/types/channels'

export type UpSellTableDataType = {
  id: string
  name: string
  entitledProductIds: string[]
  entitledProducts: UpsellEntitledProductType[]
  entitledCollections?: UpsellEntitledCollectionType[]
  prerequisiteProductIds: string[]
  prerequisiteVariantIds: string[]
  prerequisiteCollectionIds: string[]
  viewCount: number
  appliedCount: number
  gmvProcessed: number
  isActive: boolean
  createdAt: Date
  updatedAt: Date
  activeFrom: Date
  activeUntil?: Date
  metadata: any
  groupConversion?: string
}

export type UpsellDiscountType = {
  type: 'PERCENTAGE' | 'NONE'
  concessionAmount: number
}

export type UpsellEntitledProductType = {
  productId: string
  productDiscount: UpsellDiscountType
}

export type UpsellEntitledCollectionType = {
  collectionId: string
  collectionDiscount: UpsellDiscountType
}

export type EntitledCatalogueConfigType = {
  valueType?: CatalogueCategoryType
  items?: UpsellEntitledProductType[]
  variants?: string[]
  catalogueMetadata?: CatalogueDataType[]
}

export type EntitledCollectionCatalogueConfigType = {
  valueType?: CatalogueCategoryType
  items?: UpsellEntitledCollectionType[]
  catalogueMetadata?: CatalogueDataType[]
}

export type EntitlementsConfigType = {
  valueType: CoverageType
  entitledItemsConfig: EntitledCatalogueConfigType
  entitledCollectionsConfig?: EntitledCollectionCatalogueConfigType
}

export type PrerequisitesConfigType = {
  valueType: PrerequisiteType
  prerequisiteItemsConfig?: CatalogueConfigType
}

export type UpSellFormStateType = {
  name: string
  entitlementsConfig: EntitlementsConfigType
  prerequisitesConfig: PrerequisitesConfigType
  realEstate: UpSellPlacementType[]
  channels: ChannelConfigType[]
}

export type UpSellPlacementType = 'CART' | 'CHECKOUT'
export type JourneyStepType = 'setup' | 'condition' | 'preview'
export type JourneyLineActionType = 'hide' | 'disable'

export type JourneyLineStepConfigType = {
  isDisabled?: boolean
  isHidden?: boolean
  label?: string
  step?: JourneyStepType
}

export enum UpsellAnalyticsWidgetSet {
  GENERIC_WIDGET = 'generic',
  PRODUCT_DISTRIBUTION_WIDGET = 'product_distribution',
  PRODUCT_COMBINATION_WIDGET = 'product_combination'
}

export type UpSellProductVariantType = {}

export type UpsellAnalyticsProductType = {
  id: string
  name: string
  description: string
  imageURL: string
  type: string
  variants?: UpSellProductVariantType[]
}

export type UpsellAnalyticsProductDistributionType = {
  product: UpsellAnalyticsProductType
  soldQuantity: number
}

export type UpsellAnalyticsProductCombinationType = {
  originalProduct: UpsellAnalyticsProductType
  upSoldProduct: UpsellAnalyticsProductType
  timesSold: number
}

export type UpsellProductDistributionWidgetType = {
  products: UpsellAnalyticsProductDistributionType[]
  additionalWidgets: GenericAnalyticsWidgetType[]
  requestConfig: Omit<GenericAnalyticsWidgetDataRequestType, 'parser'> & {
    parser: (response: any) => UpsellAnalyticsProductDistributionType[]
  }
}

export type UpsellProductCombinationWidgetType = {
  combinations: UpsellAnalyticsProductCombinationType[]
  requestConfig: Omit<GenericAnalyticsWidgetDataRequestType, 'parser'> & {
    parser: (response: any) => UpsellAnalyticsProductCombinationType[]
  }
}

export type UpsellAnalyticsWidgetType =
  | {
      type: UpsellAnalyticsWidgetSet.GENERIC_WIDGET
      data: GenericAnalyticsWidgetType
    }
  | {
      type: UpsellAnalyticsWidgetSet.PRODUCT_DISTRIBUTION_WIDGET
      data: UpsellProductDistributionWidgetType
    }
  | {
      type: UpsellAnalyticsWidgetSet.PRODUCT_COMBINATION_WIDGET
      data: UpsellProductCombinationWidgetType
    }

export type UpsellDetailsTableRowType = {
  id: string
  productName: string
  productImage: string
  offer: UpsellDiscountType
  addedCount?: number
  purchasedCount?: number
  viewCount?: number
  itemType?: 'PRODUCT' | 'COLLECTION'
}

export type WidgetProductType = {
  order_count?: number
  title?: string
}

export interface UpsellSetupTabProps {
  searchText?: string
}
